import Vue from 'vue'
import VueMeta from 'vue-meta'
import Vue2Filters from 'vue2-filters'
import VueLazyload from 'vue-lazyload'
// import firebase from 'firebase/app'

import router from './router'
import store from './store'

import Utils from './plugins/utils'
import Mixins from './plugins/mixins'
import EventHub from './plugins/eventHub'

import App from './App.vue'


// ----- Initialize Firebase -----

// firebase.initializeApp({
//   apiKey: 'AIzaSyCrplIDMquWEWEIz25pg20JCjGJnjQJcpA',
//   authDomain: 'pri-colle.firebaseapp.com',
//   databaseURL: 'https://pri-colle.firebaseio.com',
//   projectId: 'pri-colle',
//   storageBucket: 'pri-colle.appspot.com',
//   messagingSenderId: '750237001497',
//   appId: '1:750237001497:web:3dbf529b7874e510'
// })


// ----- Initialize VueApp -----

Vue.use(VueMeta)
Vue.use(Vue2Filters)
Vue.use(VueLazyload)
Vue.use(Utils)
Vue.use(Mixins)
Vue.use(EventHub)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')

